import { render } from "./DeveloperInfo.vue?vue&type=template&id=503188db&scoped=true"
import script from "./DeveloperInfo.vue?vue&type=script&lang=js"
export * from "./DeveloperInfo.vue?vue&type=script&lang=js"

import "./DeveloperInfo.vue?vue&type=style&index=0&id=503188db&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503188db"]])

export default __exports__